import React from "react";

const LivePulseDot = ({ color = "#16A34A", size = 8 }) => (
  <span
    style={{
      position: "relative",
      display: "inline-block",
      width: size,
      height: size
    }}
  >
    <span
      style={{
        position: "absolute",
        inset: 0,
        borderRadius: "50%",
        background: color,
        animation: "muv2-pulse 2s ease-in-out infinite"
      }}
    />
    <span
      style={{
        position: "absolute",
        inset: 2,
        borderRadius: "50%",
        background: color
      }}
    />
    <style>{`@keyframes muv2-pulse {
      0%, 100% { opacity: 0.30; transform: scale(1); }
      50% { opacity: 0.75; transform: scale(1.8); }
    }`}</style>
  </span>
);

export default LivePulseDot;
